import React, {
  createContext,
  ReactElement,
  useContext,
  useEffect,
} from "react";

import { AuthContext } from "../auth.context";

import { childrenNodeType } from "../../types";

//Style
import "./splashScreen.scss";

type SplashScreenContextType = {
  isLoading: boolean;
};

export const SplashScreenContext =
  createContext<SplashScreenContextType | null>(null);

export function SplashScreenProvider({
  children,
}: childrenNodeType): ReactElement {
  const { isLoading } = useContext(AuthContext);

  useEffect(() => {
    const splashScreen = document.getElementById("splash-screen");
    // console.log(visible);
    // Show SplashScreen
    if (isLoading) {
      // console.log("remove hidden", isLoading);
      splashScreen.classList.remove("d-none");
    }

    // Hide SplashScreen
    let timeout;
    if (!isLoading) {
      timeout = setTimeout(() => {
        splashScreen.classList.add("d-none");
      }, 1000);
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [isLoading]);

  return (
    <SplashScreenContext.Provider value={{ isLoading }}>
      {children}
    </SplashScreenContext.Provider>
  );
}
